<template>
  <div>
    <slotBase :bg-grey="true">
      <template v-slot:title>
        <titleBar header-title="page two" @back="back" />
      </template>
      <template v-slot:content>
        <p class="text-center f-Overpass f-w-600 f-25">
          ini isi dari component nya
        </p>
        <componentExample />

        <p class="text-center f-Overpass f-w-600 f-25">
          this is page two, and you can navigate this page
        </p>
        <p class="f-Overpass f-16 f-w-400 text-center">
          Ini hasil dari API : {{ login }}
        </p>
        <button
          class="d-flex justify-content-center btn btn-primary"
          @click="callApi"
        >
          call API
        </button>
      </template>
    </slotBase>
  </div>
</template>
<script>
import slotBase from "@/components/slots/slotBase.vue";
import titleBar from "@/components/design/titleBar.vue";
import { mapActions, mapState } from "vuex";
import componentExample from "../components/componentExample.vue";

export default {
  name: "pageTwo",
  components: {
    slotBase,
    titleBar,
    componentExample,
  },
  computed: {
    ...mapState({
      login: "login",
    }),
  },
  methods: {
    ...mapActions({
      postLogin: "postLogin",
    }),

    back() {
      this.$router.go(-1);
      this.$store.commit("removeDataApi");
    },
    callApi() {
      this.postLogin();
    },
  },
};
</script>
